import get from 'lodash/get';
import { useSelector } from 'react-redux';

import {
  LOCATION_BASE,
  LOCATION_OFFLINE
} from 'bento-ordering/locations/constants/paths';
import {
  getFulfillmentTimeOrASAPDisplaySelector,
  getTotalCartItemQuantities
} from 'bento-ordering/cart/selectors';
import { fulfillmentOptions } from 'constants/fulfillmentOptions';
import {
  getAvailableFulfillmentMethodSelector,
  areAllLocationsClosedSelector
} from 'bento-ordering/locations/selectors';
import {
  selectCartIsGroupOrder,
  selectIsGroupOrderCurrentDinerAdmin
} from 'bento-ordering/cart/selectors/index';
import { selectBrandLogo } from 'bento-ordering/brand/selectors';

function useOnlineOrderingAppBarState() {
  const {
    account,
    cart,
    restaurantLocations,
    router,
    locationThrottledTimes
  } = useSelector(state => state);
  const logo = useSelector(selectBrandLogo);
  const cartQuantity = getTotalCartItemQuantities(cart);

  const {
    online_ordering_fulfillment_method: fulfillmentMethod,
    online_ordering_location: onlineOrderingLocation
  } = cart;

  const availableFulfillmentOptions = onlineOrderingLocation
    ? getAvailableFulfillmentMethodSelector({
        restaurantLocations,
        locationThrottledTimes,
        onlineOrderingLocation,
        cart
      })
    : [];

  const fulfillmentTimeOrASAPDisplay = getFulfillmentTimeOrASAPDisplaySelector({
    restaurantLocations,
    cart,
    locationThrottledTimes
  });
  const deliveryAddress =
    fulfillmentMethod === fulfillmentOptions.DELIVERY
      ? cart.shipping_street_address_1 || 'Your Address'
      : '';
  const isClosed = areAllLocationsClosedSelector(restaurantLocations);
  const isGroupOrder = useSelector(selectCartIsGroupOrder);
  const isGroupOrderAdmin = useSelector(selectIsGroupOrderCurrentDinerAdmin);
  const displayAdminCart = isGroupOrder && isGroupOrderAdmin;

  return {
    logo,
    logoDestinationUrl: get(
      account,
      'online_ordering_general_settings.logo_destination_url'
    ),
    accountName: account.name,

    cartQuantity,
    shouldDisplayFulfillmentOptions: ![
      LOCATION_BASE,
      LOCATION_OFFLINE
    ].includes(router.location.pathname),

    shouldDisplayCart:
      router.location.pathname !== LOCATION_BASE &&
      (displayAdminCart || cartQuantity > 0),
    fulfillmentTimeOrASAPDisplay,
    fulfillmentMethod,
    availableFulfillmentOptions,
    deliveryAddress,
    isClosed
  };
}

export default useOnlineOrderingAppBarState;
